import { ObservableArray, View } from "binder"
import { BenefitCalculationTypeEnum, BenefitTypeEnum, DistrictSaleBenefitsReportViewModel, Item } from "./districtSaleBenefitsReport-viewModel"

export class DistrictSaleBenefitsReportView extends View<DistrictSaleBenefitsReportViewModel>{
    GetViewUniqueId(): string {
        return "V-B80F8341-AE22-4469-94C2-F641CF665898"
    }
    loadHtml(): string {
        let element = require('./districtSaleBenefitsReport.html').default;
        let style = require('./districtSaleBenefitsReport.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<Item>) { this._items = v; } public get items(): ObservableArray<Item> { return this._items;} private _items: ObservableArray<Item>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set enumProvider(v: BenefitTypeEnum) { this._enumProvider = v; } public get enumProvider(): BenefitTypeEnum { return this._enumProvider;} private _enumProvider: BenefitTypeEnum;
    public set calculationEnumProvider(v: BenefitCalculationTypeEnum) { this._calculationEnumProvider = v; } public get calculationEnumProvider(): BenefitCalculationTypeEnum { return this._calculationEnumProvider;} private _calculationEnumProvider: BenefitCalculationTypeEnum;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    
    load(){
        this.dataContext.load();
    }
    exportExcel(){
        this.dataContext.exportExcel();
    }
}
